export const CHARTS_COLOR_SCHEME = ["#F0E43A", "#FA7D74", "#6EB9FF"];
export const HOVER_CHARTS_COLOR_SCHEME = ["#FFC107", "#C9302C", "#31B0D5"];
export const PLUS_USER_CHARTS_COLOR_SCHEME = ["#6EB9FF", "#FA7D74"];
